import api from '@services/api'

// export const SET_SONGS = 'SET_SONGS'
// export const SET_SONGS = 'SET_SONGS'

export const setSongs = (songs) => {
    console.log('setSongs songs = ', songs)
    return {
        type: 'SET_SONGS',
        songs,
    }
}

export const setVersions = (versions) => {
    console.log('setVersions vers = ', versions)
    return {
        type: 'SET_VERSIONS',
        versions,
    }
}
